import PropTypes from 'prop-types';

export const SlidePropTypes = {
	urlDest: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	imgXl: PropTypes.string.isRequired,
	imgL: PropTypes.string.isRequired,
	imgM: PropTypes.string.isRequired,
	imgS: PropTypes.string.isRequired,
};
